import React from "react";
import type { RichTextSlice } from "~/lib/prismic/types.generated";
import type { SliceComponentProps } from "@commercekit/prismic";
import WvRichTextWithHeading from "./variations/RichTextWithHeading";
import WvRichTextWithoutHeading from "./variations/RichTextWithoutHeading";

const RichText = ({ slice }: SliceComponentProps<RichTextSlice>) => {
  switch (slice.variation) {
    case "default": {
      return <WvRichTextWithHeading slice={slice} />;
    }
    case "richTextWithoutHeading": {
      return <WvRichTextWithoutHeading slice={slice} />;
    }
    default:
      return <div className="hidden">Content</div>;
  }
};

export default RichText;
